// JScript File

// JScript File


function getComparisonSearcherEngin() {
           
    let xmlHttp = (window.ActiveXObject) ? new ActiveXObject("Microsoft.XMLHTTP") : new XMLHttpRequest()
    let xmlHttp2 = (window.ActiveXObject) ? new ActiveXObject("Microsoft.XMLHTTP") : new XMLHttpRequest()
    let xmlHttp3 = (window.ActiveXObject) ? new ActiveXObject("Microsoft.XMLHTTP") : new XMLHttpRequest()

    let engin = {
        arrComparison: [],
        globesChart: undefined,

        instrumentElement : function(sFeeder, sInstId, sSymbol, sExchange, iActive, sColor) {
            this.id = sInstId;
            this.active = iActive;
            this.color = sColor;
            this.feeder = sFeeder;
            this.symbol = sSymbol;
            this.exchangeId = sExchange;
        },


        

        init: function (globesChart) {

            if (globesChart != undefined)
                this.globesChart = globesChart;
            else
                if (typeof window.globesChart != 'undefined')
                    this.globesChart = window.globesChart;

            this.globesChart.setMaxSymbols(10);
            let state = JSON.parse(localStorage.getItem('state')),
                tab = state != undefined ? state.tab : undefined,
                isSymbolExists = state != undefined && state.symbols != undefined && state.symbols.length > 0 && state.symbols[0] == comparisonSymbols[0],
                stateArrComparison = isSymbolExists && state.arrComparison != undefined ? state.arrComparison : [],
                symbols = isSymbolExists ? state.symbols : [],
                symbolsLength = symbols.length,                                
                stateArrLength = stateArrComparison.length,
                me = this;

            if (tab == 'compare' && symbolsLength > 0 && stateArrLength > 0 && symbolsLength == stateArrLength) {
                this.arrComparison = stateArrComparison;
                this.RefreshDataAndGraph(true)
            } else {

                if (typeof instInitParams != 'undefined' && Array.isArray(instInitParams)) {
                    for (var i = 0; i < instInitParams.length; i++) {
                        this.arrComparison[i] = new this.instrumentElement(instInitParams[i][0], instInitParams[i][1], instInitParams[i][2], instInitParams[i][3], true, Highcharts.defaultOptions.colors[i])
                    }
                    this.RefreshDataAndGraph(true)
                    
                }
            }
            
            if (is_mobile) { this.hideGraphHelpDiv(); }// this.hideSearchBox()}
        },

        selAjaxResult_onClick: function(obj) { //alert('selAjaxResult_onClick')

            //obj.style.display = "none"
        },




         query_keyUp : function(event, caller, selObjName) { //alert("query_keyUp")
            var ar = document.getElementById(selObjName)
            if (event) {
                var keyCode = event.keyCode
                //alert(keyCode + " " + caller.id)
                switch (keyCode) {
                    case 40: // key down
                        //                    }
                        return;
                    case 38: // key up
                        return;
                    case 13: //enter
                        return;
                    case 9: //tabarraa
                        return;
                    case 27: //esc
                        ar.style.display = "none"
                        $(ar).parent().removeClass('open')
                        return;
                    default:

                }
            }
            this.ajax_instrumentList(caller, selObjName)
        },

         cleanAndCloseHelpDiv: function () {
             var oDiv = document.getElementById("divGraphHiddenSearch");
             var parent = $('#divSearchBox')
             if (($(oDiv)).parent().attr("id") == 'divSearchIndicesBox')
                 parent = $('#divSearchIndicesBox');
            var oQuery = parent.find('.queryForGraph').get(0)
            this.hideGraphHelpDiv(4);
            //oQuery.value = "";
            
            
            oQuery.focus();
        
         },
        
        hideGraphHelpDiv: function (i) {
            
            //g_isHiddenDivDisplayed = 0;
            var objDivHiddenSearch = document.getElementById("divGraphHiddenSearch")
            if (objDivHiddenSearch != null && objDivHiddenSearch.style.display == "block") {
                try {
                    objDivHiddenSearch.style.display = "none";
                    objDivHiddenSearch.innerHTML = "";
                    $(objDivHiddenSearch).parent().removeClass('open')
                }
                catch (e) { }
            }
         },
        OnBlurGraphText: function () {
            var objHidDiv = document.getElementById("hidIsGraphDivOpen");
            if (objHidDiv && parseInt(objHidDiv.value) == 0) {
                this.hideGraphHelpDiv(3);
            }
        },
        getGraphEnter: function (e) {
            
        },
        UpdateSymboles: function (s) {
            //arrComparison = s;
        },

        ajax_instrumentList: function (caller, selObjName) {
            var me = this;
            try {
                xmlHttp.abort()
                var ar = document.getElementById(selObjName)
                try {
                    // ar.style.display = "none" 
                    ar.innerHTML = "";

                } catch (err) { }
                var q = caller.value

                if (q.length == 0) { return }
                
                
                var url = "";
                if (instrumentType == "קרן נאמנות") {
                    url = "/portal/handlers/FundsListHandler.ashx?strToSearch=" + escape(q);
                }
                else {
                    var sFeeder = document.getElementById("hidFeeder").value
                    url = "/portal/handlers/ETFListHandler.ashx?strToSearch=" + escape(q) + "&feeder=" + sFeeder
                }
                    

                xmlHttp.open("GET", url, true)
                xmlHttp.onreadystatechange = function () {
                    if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
                        //if (xmlHttp.responseText.length == 0) {
                        //    //caller.value = ""; return;
                            
                        //}
                        var responseText = xmlHttp.responseText.length > 0 ? xmlHttp.responseText.split('~') : []
                        if (responseText.length > 0) {
                            // init(caller,selObjName)
                            me.build_InstrumentsList_ajax_result(responseText, selObjName, 0, caller)
                        } else {                            
                            me.hideGraphHelpDiv(2);
                        }
                    }
                    


                }
                xmlHttp.send(null)
            } catch (ex) {/*alert('ajax\n' + ex.toString())*/ }
        },

         ajax_instrumentData: function (exchangeIds, symbols, objDivName, isFirstTime, isRefreshGraph) {
            var me = this;
            try {
                xmlHttp2.abort()
                var ar = document.getElementById(objDivName)
                try {
                    ar.innerHTML = "";
                } catch (err) { alert(err.description) }
                var url = "/portal/handlers/InstrumentYieldsHandler2.ashx?symbols=" + symbols + "&exchangeIds=" + exchangeIds
                xmlHttp2.open("GET", url, true)
                xmlHttp2.onreadystatechange = function () {
                    if (xmlHttp2.readyState == 4 && xmlHttp2.status == 200) {
                        if (xmlHttp2.responseText.length == 0) {
                            return
                        }
                        var responseText = xmlHttp2.responseText.split('~')
                        //init(caller,objDivName)
                        var graphParams = me.Build_DataTable_ajax_results(responseText, objDivName, symbols)
                        if(!isFirstTime && isRefreshGraph)
                            me.refreshGraph(graphParams);
                        
                    }
                }
                xmlHttp2.send(null)
            } catch (ex) { alert('ajax\n' + ex.toString()) }
        },

        ajax_indices: function (caller, objDivName) {
            var me = this;
            try {
                xmlHttp3.abort()
                var ar = document.getElementById(objDivName)
                try {
                    ar.innerHTML = "";
                } catch (err) { alert(err.description) }
                var type = caller.options[caller.selectedIndex].value;
                if (type == 0)
                    return;

                var url = "/portal/handlers/InstrumentIndicesHandler.ashx?type=" + type;
                if (instrumentType != "קרן נאמנות") {
                    if (instrumentType == '')
                        url += "&feeder=0";
                    else {
                        var sFeeder = document.getElementById("hidFeeder").value
                        url += "&feeder=" + sFeeder
                    }
                }
               
                xmlHttp3.open("GET", url, true)
                xmlHttp3.onreadystatechange = function () {
                    if (xmlHttp3.readyState == 4 && xmlHttp3.status == 200) {
                        if (xmlHttp3.responseText.length == 0) {
                        }
                        var responseText = xmlHttp3.responseText.split('~')                        
                        var graphParams = me.build_InstrumentsList_ajax_result(responseText, objDivName, 1, caller)                       
                    }
                }
                xmlHttp3.send(null)
            } catch (ex) { alert('ajax\n' + ex.toString()) }

        },

        _build_InstrumentsList_ajax_result : function(results, selObjName, isIndices) {
            
            var objSel = document.getElementById(selObjName)
            var html = "<table cellpadding='1' cellspacing='1' border='0' width='100%'>"
            for (var i = 0; i < results.length; i++) {
                var arrInstruments = results[i].split('|')
                var name = arrInstruments[0]
                var exchange = (isIndices == 1 ? arrInstruments[1] : 45);
                var symbol = arrInstruments[2];
                //var id = arrInstruments[3];
                //var feeder = arrInstruments[4];
               // var instParam = id + "|" + feeder;
                html += "<tr "  
                     + (isIndices == 1
                        ? (" onclick='searcher.addInstrument(" + exchange + ",\"" + symbol + "\")'")
                        : (" onclick='searcher.addInstrument(" + exchange + "," + symbol + ")'")
                        ) 
                    + "><td width='150'>" + name + "</td></tr >" 
                    
                    
            }
            html += "</table>"
            objSel.innerHTML = html
            $(objSel).find("table tr").mouseover(function () { $(this).addClass('selected') });
            $(objSel).find("table tr").mouseout(function () { $(this).removeClass('selected') });
            objSel.style.display = "block"
            $(objSel).parent().addClass("open")
        },

        build_InstrumentsList_ajax_result : function(results, selObjName, isIndices, caller) {
            
            var objSel = document.getElementById(selObjName)

            var prevType = "";            
            var html = "<table id='tblHiddenSearch' cellpadding='1' cellspacing='1' border='0' width='100%' >"
            html += '<tr><td class="title1" width="80%">שם נייר</td><td class="title1" width="19%">סימול</td></tr>';

            var prevType = "";
            var sGraphDelim = "|";

            for (var i = 0; i < results.length; i++) {
                if(results[i].length == 0)
                    continue; 
                var arrInstruments = results[i].split('|')
                var fullname = arrInstruments[0];
                var name = arrInstruments[0].substring(0,40)
                var exchange = (isIndices == 1 ? arrInstruments[1] : 45);
                var id = arrInstruments[1];
                var symbol = arrInstruments[2];
                var type = arrInstruments[3];
                var exchangeName = arrInstruments[4];
                var iType = parseInt(type);
                var sFeeder = exchange == 45 ? 0 : 1;
                
                
                
                
                //var id = arrInstruments[3];
                //var feeder = arrInstruments[4];
               // var instParam = id + "|" + feeder;
                var rowMouseOver = " onmouseover='searcher.onMouseOver(" + i + ")') ";
                var instrumentParam = symbol ;//id + sGraphDelim + sFeeder + sGraphDelim + symbol;
                var flagInstrumentInSymbols = this.GetSymbols(true).indexOf(instrumentParam) > -1;
                var rowClass = flagInstrumentInSymbols ? " class='selected' " : "";
                var jsTitle = fullname.replace("'", "&#39;");
                

                html += "<tr "  
                     + rowClass
                     //+ rowMouseOver
                     + (isIndices == 1
                        ? (flagInstrumentInSymbols ? '' : (" onclick='searcher.addInstrument(" + exchange + ",\"" + symbol + "\")'"))
                        : (flagInstrumentInSymbols ?  '' : (" onclick='searcher.addInstrument(" + exchange + "," + symbol + ")'"))
                        ) 
                    + "><td style='direction:rtl'  title='" + jsTitle +"'>" + name + "</td>"
                    + "<td style='text-align:left'>" + symbol + "</td>"                      
                    +"</tr >" 
            }
            var sSumLink = "";
            if (isIndices == 0 && !!is_mobile == false) {
                var sItemLink = "לכל התוצאות עבור " + " " + caller.value;
                var sItemURL = "/portal/search.aspx?searchType=exact&searchQuery=" + escape(caller.value) + "&id=7";
                sSumLink = "<tr><td colspan=2><hr style='width:99%;margin:2px 0px 2px 0px;' /></td></tr><tr class='trAllResults' onclick='ruleriHeaderSearchEvent(\"Search_QauteDiv\",\"All results\")'><td colspan=2 align='right' style='font-weight:bold;padding:0px 5px 5px 5px;display:inline;'><a href='" + sItemURL + "' style='color:#cc0000;float:right;'>" + sItemLink + "</a></td></tr>";
            } 

            html += sSumLink  + "</table>";
            objSel.innerHTML = html
            $(objSel).find("table tr").mouseover(function () { $(this).addClass('selected') });
            $(objSel).find("table tr").mouseout(function () { $(this).removeClass('selected') });
            objSel.style.display = "block"
            $(objSel).parent().addClass("open")
        },




        Build_DataTable_ajax_results: function (results, objDivName, symbols) {
            var me = this;            

            var arrSymbols = symbols.split(',')
            var arrSortedResult = results.sort(function(a,b){ 
                var symbol1 = a.split('|')[1];
                var symbol2 = b.split('|')[1]
                var subTract = arrSymbols.indexOf(symbol1) - arrSymbols.indexOf(symbol2)
                if (subTract > 0) return 1;
                if (subTract < 0) return -1;
                return 0;
            });
           

            var instParams = []
            var selPeriodValue = this.GetSelPeriod("data-key");
            var html = '<table cellpadding="0" cellspacing="0" border="0" width="100%" dir="rtl" class="tblChannel">' +
                '<tr><td class="instrumentTitle">&nbsp;</td>' +
                '<td colspan= "2" class="instrumentTitle topInstrument_BorderRight" > שם נייר ערך</td > ' +
                '<td class="instrumentTitle currPeriod" width="100">תשואה לתקופה</td>' +
                '<td class="instrumentTitle" width="100">תשואה  חודשית</td>' +
                '<td class="instrumentTitle" width="100">תשואה מתחילת השנה</td>' +
                '<td class="instrumentTitle" width="50">דמי ניהול</td>' +
                '<td class="instrumentTitle" width="20">&nbsp;</td></tr>'
            for (var i = 0; i < arrSortedResult.length; i++) {
                var arrData = arrSortedResult[i].split('|')
                var name = arrData[0]
                var symbol = arrData[1]
                var id = arrData[2]
                var time = arrData[3]
                var fee = arrData[4]
                var PCWeek = arrData[5]
                var PCMonth = arrData[6]
                var PCBMonth = arrData[7]
                var PC2M = arrData[8]
                var PC3M = arrData[9]
                var PC6M = arrData[10]
                var PCBYear = arrData[11]
                var PC1Y = arrData[12]
                var PC3Y = arrData[13]
                var PC5Y = arrData[14]

                var indexInArr = this.getInstrumentIndex(symbol)
                if (indexInArr < 0)
                    continue;

                var color = Highcharts.defaultOptions.colors[indexInArr]
                //update missing data    
                var exchangeId = this.arrComparison[indexInArr].exchangeId;
                var feeder = exchangeId == 45 || exchangeId == 9 ? '0' : '1';   
                
                if (this.arrComparison[indexInArr].id == 0) {
                    this.arrComparison[indexInArr].id = id;                                      
                    this.arrComparison[indexInArr].feeder = feeder;

                    this.globesChart.updateState({
                        arrComparison: this.arrComparison
                    });
                }                
                

                var selectedPeriodData = "";
                
                switch (selPeriodValue) {
                    case 'w': selectedPeriodData = PCWeek; break;
                    case '1m': selectedPeriodData = PCMonth; break;
                    case 'bm': selectedPeriodData = PCBMonth; break;
                    case '2m': selectedPeriodData = PC2M; break;
                    case '3m': selectedPeriodData = PC3M; break;
                    case '6m': selectedPeriodData = PC6M; break;
                    case 'by': selectedPeriodData = PCBYear; break;
                    case '1y': selectedPeriodData = PC1Y; break;
                    case '3y': selectedPeriodData = PC3Y; break;
                    case '5y': selectedPeriodData = PC5Y; break;
                }
                
                

                var checkedString = (indexInArr < 0) ? "checked" : (this.arrComparison[indexInArr].active == 1 ? "checked" : "");
                var removeLink = '<a href="javascript:void(0)" onclick="searcher.removeInstrument(\'' + symbol + '\')">X</a>';
                removeLink = (i > 0 ) ? removeLink : "&nbsp;";
                var instParam = id + "|" + feeder + "|" + symbol;
                instParams.push(instParam); 

                html += '<tr data-id="'+ instParam +'"><td class="tdInstrumentData" width="15"><input onClick="searcher.chk_click(this)" type="checkbox" id="ckb_' + i + '" value="' + symbol + '" ' + checkedString + ' /></td>' +
                    '<td class="tdInstrumentData" width="15"><div class="instrumentGraphSquare" style="background-color:' + color + '"><img src="https://images.globes.co.il/images/serve/images/pixel.gif" width="1" height="1" alt="" /></div></td>' +
                    '<td class="tdInstrumentData" width="200" style="direction:rtl;"><a href="/portal/instrument.aspx?instrumentid='+ id + (feeder!='0' ? '&feeder=1' : '') + '">' + name + '</a></td>' +
                    '<td class="tdInstrumentData data"  data-w="'+ PCWeek +'" data-1m="'+ PCMonth +'" data-3m="'+ PC3M +'" data-6m="' + PC6M + '" data-1y="'+ PC1Y +'" data-3y="'+ PC3Y +'" data-5y="'+ PC5Y + '">' + selectedPeriodData + '</td>' +
                    '<td class="tdInstrumentData">' + PCMonth + '</td>' +
                    '<td class="tdInstrumentData">' + PCBYear + '</td>' +
                    '<td class="tdInstrumentData" width="50">' + fee + '</td>' +
                    '<td class="tdInstrumentData last" >' + removeLink + '</tr>'
            }
            html += '</table>'

            //sort rows
            var arrIds = me.arrComparison.map((item, index) => { return item.id });
            var arrRows = $(html).find("tr[data-id]").slice();
            var sortRows = arrRows.sort(function (a, b) {
                var id1 = $(a).attr("data-id").split('|')[0];
                var id2 = $(b).attr("data-id").split('|')[0];
                return arrIds.indexOf(id1) > arrIds.indexOf(id2)
            });
            
            $(html).find("tr[data-id]").html(sortRows)

            

            document.getElementById(objDivName).innerHTML = html;

            return instParams;
        },

        refreshGraph: function (params) {
            for (var i = 0; i < params.length; i++) {
                var foundItem = globesChart.symbols.find((param) => { return param == params[i] });
                if (comparisonSymbols.length == 0 && params.length == 1) {                     
                    this.globesChart.initFirstTime(params[i])

                } else {
                    if (foundItem == undefined)
                        this.globesChart.addInstrumentToComparison(params[i]);
                }
            }
        },
        

           

        addInstrument: function(exchangeId, symbol) {
            if (this.IsSymbolInArray(symbol)) {
                alert('הנייר כבר קיים ברשימת ההשוואה');
            }
            else {
                if (this.arrComparison.length < 10) {
                    this.arrComparison[this.arrComparison.length] = new this.instrumentElement('', 0, symbol, exchangeId, true, Highcharts.defaultOptions.colors[this.arrComparison.length])     //arrSymbols[arrSymbols.length] = symbol
                    this.RefreshDataAndGraph();

                    this.globesChart.updateState({
                        arrComparison: this.arrComparison
                    });
                }
                else
                    alert('ניתן להשוות רק עד 10 ניירות ')
            }

        },
         IsSymbolInArray: function(symbol) {
            var flagExist = false;
            for (var i = 0; i < this.arrComparison.length; i++) {
                if (this.arrComparison[i].symbol == symbol)
                    flagExist = true
            }
            return flagExist;
        },

         findRangeSelectionAttrName: function () {
             var selPeriod = $(".rangeSelectorLine .customRangeSelectorButtons .rangeSelector.selected").attr('data-type')
             var selCount = $(".rangeSelectorLine .customRangeSelectorButtons .rangeSelector.selected").attr('data-count')
             var attrName = '';
             var periodName = 'תשואה לתקופה'
             switch (selPeriod) {
                 case 'week':
                     attrName = 'data-w';
                     periodName = 'תשואה שבועית'
                     break;
                 case 'month':
                     attrName = 'data-' + selCount + 'm';
                     periodName = 'תשואה ' + selCount + ' ח\'';
                     break;
                 case 'year':
                     attrName = 'data-' + selCount + 'y';
                     periodName = 'תשואה ' + selCount + ' שנים';
                     break;
                 case 'all':
                     attrName = '';
                     break;
             }

             return { attrName: attrName, periodName: periodName }
         },
         changeRangeSelection: function (index) {
             var rangeSelectionData = this.findRangeSelectionAttrName()
             if (rangeSelectionData.attrName == '') {
                 $("#divCompareList table tr td.data").html('--')
             } else {

                 $("#divCompareList table tr td.data").each(function (index, item) {
                    $(this).html($(this).attr(rangeSelectionData.attrName))    ;
                 })
             }

             $("#divCompareList table tr td.currPeriod").html(rangeSelectionData.periodName)             
         },

        removeInstrument : function(symbol) {
            var index = this.getInstrumentIndex(symbol)
            var instParam = index >= 0 ? this.arrComparison[index].id + "|" + this.arrComparison[index].feeder + "|" + this.arrComparison[index].symbol : "";
            if (index >= 0) {
                this.arrComparison.splice(index, 1);               
                for (var i = 0; i < this.arrComparison.length; i++) {
                    this.arrComparison[i].color = Highcharts.defaultOptions.colors[i];
                }
                this.globesChart.removeInstrumentFromOutside(instParam);
                //this.RefreshDataAndGraph(false, false);
                $("#divCompareList table tr[data-id='" + instParam + "']").remove();

                this.globesChart.updateState({
                    arrComparison: this.arrComparison
                });
            }
         },
        

         chk_click: function(chkObj) {
            var active = chkObj.checked
            var index = this.getInstrumentIndex(chkObj.value)
            this.arrComparison[index].active = active
            var id = this.arrComparison[index].id + "|" + this.arrComparison[index].feeder + "|" + this.arrComparison[index].symbol;
            this.globesChart.hideSeries(id, active);

            
        },
        
               
         getInstrumentIndex: function (symbol) {
             return this.arrComparison.findIndex(function (item) { return item.symbol == symbol.toUpperCase(); });
         },
         getInstrumentColor: function(symbol) {
            var index = this.getInstrumentIndex(symbol.toUpperCase())
            if (index >= 0)
                return Highcharts.defaultOptions.colors[index]
            return '000000'
         },

        
         RefreshDataAndGraph: function(isFirstTime = false, isRefreshGraph = true) {
            var symbols = this.GetSymbols(0)
            var graphExchanges = this.GetExchanges(0)            
            this.ajax_instrumentData(graphExchanges, symbols, "divCompareList", isFirstTime, isRefreshGraph);
        },
         GetSelPeriod: function (attrName) {
             var $rangeSelectors = $(".customRangeSelectorButtons .rangeSelector")
             var $selected =  $rangeSelectors.find(".selected")
             var selIndex = typeof $selected != 'undefined' && $selected.length == 0 ? 0 : $rangeSelectors.index($selected[0])

             var session = this.globesChart.localSessionRead();
             if (session != undefined && session.tab == 'compare' && session.arrComparison != undefined) {
                 if (session.rangeSelector != undefined) {
                     let type = session.rangeSelector.type;
                     let count = parseInt(session.rangeSelector.count);
                     selIndex = this.GetRangeIndexByRangeType(type, count);
                 } else {
                     selIndex = 0;
                 }
             }

             return $rangeSelectors.eq(selIndex).attr(attrName);
         },

         GetRangeIndexByRangeType: function (type, count) {
             let selIndex = 0;
             switch (type) {
                     case 'week':
                         selIndex = 0;
                         break;
                     case 'month':
                         if (count == 1)
                             selIndex = 1;
                         else {
                             if (count == 3)
                                 selIndex = 2;
                             else
                                 selIndex = 3
                         }
                         break;
                     case 'year':
                         if (count == 1)
                             selIndex = 4;
                         else {
                             if (count == 3)
                                 selIndex = 5;
                             else
                                 selIndex = 6
                         }
                         break;
                     case 'all':
                         selIndex = 7;
                         break;
                     default:
                         selIndex = 0;
                         break;

             }
             return selIndex;
         },

         GetPropList: function (propToCollect, isGraph) {
            var list = "";
            for (var i = 0; i < this.arrComparison.length; i++) {
                if ((this.arrComparison[i].active == 1 && isGraph == 1) || isGraph == 0) {
                    if (propToCollect == 'symbol') {
                        if (this.arrComparison[i].symbol.toString() != "0")
                            list += this.arrComparison[i].symbol + ",";
                    }
                    if (propToCollect == 'exchangeId') {
                        if (this.arrComparison[i].exchangeId.toString() != "0")
                            list += this.arrComparison[i].exchangeId + ",";
                    }
                }
            }
            if (list.length > 0)
                list = list.substr(0, list.length - 1)
            return list;
         },
         
         GetSymbols: function (isGraph) {
             return this.GetPropList('symbol', isGraph);
         },

         GetExchanges: function (isGraph) {
            return this.GetPropList('exchangeId', isGraph);
         },

         changeTheme: function () {
             $("#divCompareList table tr[data-id]").each(function (index) {
                 var instId = $(this).attr('data-id')
                 var series = this.globesChart.seriesOptions.find((elem) => elem.id == instId);
                 if (series != undefined) {
                     $(this).find("td .instrumentGraphSquare").css("backgroundColor",series.color);
                 }
             });             
         },

         reset: function () {
             this.arrComparison.length = 0;
             if (typeof instInitParams != 'undefined' && Array.isArray(instInitParams) && instInitParams.length > 0) {
                 for (var i = 0; i < instInitParams.length; i++) {
                     this.arrComparison[i] = new this.instrumentElement(instInitParams[i][0], instInitParams[i][1], instInitParams[i][2], instInitParams[i][3], true, Highcharts.defaultOptions.colors[i])
                 }
                 this.RefreshDataAndGraph(true)
             }
             else {
                  document.getElementById("divCompareList").innerHTML = ''
             }

         },
         toExcel: function () {           

            window.open("/portal/instrument/instrumentgraph_toexcel.aspx?instrumentid=" + instrumentid[0] + "&feeder=" + feeder[0], "graphExcel");

        },



    }

    return engin;
}

window.searcher = getComparisonSearcherEngin();

$(function () {
    $("#divSearchBox, #divSearchIndicesBox").click(function (e) {        
        $("#divGraphHiddenSearch").html('')
        $("#divSearchBox").find('.queryForGraph').val('')
        $(this).append($("#divGraphHiddenSearch"));
        if ($(this).attr('id') == 'divSearchBox') {
            $("#query_for_indices").selectedIndex = 0
        }
        
    });
    
    $("#query_for_graph").keyup(function (e) {
        searcher.query_keyUp(e, this, "divGraphHiddenSearch");
    });
    $("#query_for_indices").change(function () {
        searcher.ajax_indices(this, "divGraphHiddenSearch");
    });
});


